/* eslint-disable */
import { phoneTypes } from '@ringcentral-integration/commons/enums/phoneTypes';
export default {
  [phoneTypes.business]: 'Téléphone bureau',
  [phoneTypes.extension]: 'Numéro d’extension',
  [phoneTypes.home]: 'Numéro du domicile',
  [phoneTypes.mobile]: 'Téléphone mobile',
  [phoneTypes.phone]: 'Téléphone',
  [phoneTypes.unknown]: 'Type de téléphone inconnu',
  [phoneTypes.company]: 'Numéro de l’entreprise',
  [phoneTypes.direct]: 'Numéro direct',
  [phoneTypes.contact]: 'Contact téléphonique',
  [phoneTypes.fax]: 'Fax',
  [phoneTypes.other]: 'Autre',
};

// @key: @#@"[phoneTypes.business]"@#@ @source: @#@"Business Phone"@#@
// @key: @#@"[phoneTypes.extension]"@#@ @source: @#@"Extension Number"@#@
// @key: @#@"[phoneTypes.home]"@#@ @source: @#@"Home Number"@#@
// @key: @#@"[phoneTypes.mobile]"@#@ @source: @#@"Mobile Phone"@#@
// @key: @#@"[phoneTypes.phone]"@#@ @source: @#@"Phone"@#@
// @key: @#@"[phoneTypes.unknown]"@#@ @source: @#@"Unknown Phone Type"@#@
// @key: @#@"[phoneTypes.company]"@#@ @source: @#@"Company Number"@#@
// @key: @#@"[phoneTypes.direct]"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"[phoneTypes.contact]"@#@ @source: @#@"Contact Phone"@#@
// @key: @#@"[phoneTypes.fax]"@#@ @source: @#@"Fax"@#@
// @key: @#@"[phoneTypes.other]"@#@ @source: @#@"Other"@#@
